import React from "react";
import TeacherPageContainer from "../Container/TeacherPageContainer";
import JobListingFull from "../../Components/JobListingFull/JobListingFull";
import ConfirmButton from "../../Components/Buttons/ConfirmButton";
import CancelButton from "../../Components/Buttons/CancelButton";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { API } from "../../API";
import { notify } from "react-notify-toast";

function JobListing(props) {
  const { job, inst, campus } = props;
  // const isOwnListing = job.inst_id === props.institution._id;

  const handleDelete = (id) => {
    API.deleteListing(id)
      .then((res) => {
        notify.show("Listing deleted successfully");
        props.history.push("/MyListings");
      })
      .catch((err) => {
        console.log(err.response);
        notify.show("Error deleting listing");
      });
  };

  let tabs = [
    // {
    //   text: "Search Jobs",
    //   pathname: "/JobBoard",
    // },
    {
      text: "Job Listing",
      pathname: `/JobListing/${job._id}`,
      active: true,
    },
    {
      text: "View Applicants",
      pathname: `/JobListing/ApplicantsAdmin/${job._id}`,
    }
  ];

  if (job.status === "published" || job.inst_id === props.institution._id) {
    return (
      <TeacherPageContainer header="Job Board" tabs={tabs} user={props.user}>
        <JobListingFull
          job={job}
          inst={inst}
          campus={campus}
          showSharePopup={props.location.state && props.location.state.showSharePopup}
          isAdmin
        />
        {/* {isOwnListing && (
          <div className="mt-3 row justify-content-center">
            <div className="col-lg-3 mt-2">
              <CancelButton onClick={() => props.history.push("/MyListings")}>
                Back to My Listings
              </CancelButton>
            </div>
            <div className="col-lg-3 mt-2">
              <CancelButton
                onClick={(e) => handleDelete(job._id)}>
                Delete Listing
              </CancelButton>
            </div>
            <div className="col-lg-3 mt-2">
              <ConfirmButton
                onClick={() =>
                  props.history.push(`/JobListing/Edit/${job._id}`)
                }
              >
                Edit Listing
              </ConfirmButton>
            </div>
          </div>
        )} */}
      </TeacherPageContainer>
    );
  } else {
    // will need to define how this is rendered for people w/o viewing permissions
    return "test";
  }
}

function mapStateToProps(state) {
  return {
    user: state.user.user,
    // institution: state.college.institution,
  };
}

export default connect(mapStateToProps)(withRouter(JobListing));
